export default "### Complete reconditioning\n\nQuality detailing and complete conditioning means your car arrives in better condition than we found it.\n";